import { Product } from './api';

export interface CartItem {
  product: Product;
  quantity: number;
}

const CART_KEY = 'cart_items';

export const cartService = {
  getCart(): CartItem[] {
    const data = localStorage.getItem(CART_KEY);
    if (!data) return [];
    try {
      return JSON.parse(data) as CartItem[];
    } catch {
      return [];
    }
  },

  saveCart(cart: CartItem[]) {
    localStorage.setItem(CART_KEY, JSON.stringify(cart));
  },

  addToCart(product: Product, quantity: number = 1) {
    const cart = this.getCart();
    const index = cart.findIndex(item => item.product.id === product.id);
    if (index > -1) {
      cart[index].quantity += quantity;
    } else {
      cart.push({ product, quantity });
    }
    this.saveCart(cart);
  },

  updateQuantity(productId: number, quantity: number) {
    const cart = this.getCart();
    const index = cart.findIndex(item => item.product.id === productId);
    if (index > -1) {
      cart[index].quantity = quantity;
      if (cart[index].quantity <= 0) {
        cart.splice(index, 1);
      }
      this.saveCart(cart);
    }
  },

  removeFromCart(productId: number) {
    const cart = this.getCart().filter(item => item.product.id !== productId);
    this.saveCart(cart);
  },

  clearCart() {
    localStorage.removeItem(CART_KEY);
  },
}; 